import { Injectable } from '@angular/core';
import { SiteConfigService } from '@services/site-config.service';
import { Apollo } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Product } from '../models';
import { ProductDTO } from '../types';
import { MapperFactory } from '../utils/mappers/mapper-factory';
import { ProductMapper } from '../utils/mappers/product.type.mapper';
import { MapperParams } from '../utils/mappers/type.mapper';
import {
  FundDataServiceParams,
  GraphQLFundDataService,
} from './graphql-fund-data.service';

@Injectable({
  providedIn: 'root',
})
export class FundPortfolioService extends GraphQLFundDataService {
  constructor(
    apollo: Apollo,
    siteConfigService: SiteConfigService,
    private productMapperFactory: MapperFactory
  ) {
    super(apollo, siteConfigService);
  }

  public register(
    query: DocumentNode,
    fundDataServiceParams: FundDataServiceParams
  ): Observable<Product> {
    return super.register(query, this.getVariables(fundDataServiceParams)).pipe(
      map((fundPortfolio) => {
        const productDto: ProductDTO = fundPortfolio?.data?.Portfolio
          ? fundPortfolio.data.Portfolio
          : null;

        const mappperParams: MapperParams = {
          config: this.siteConfigService,
        };

        return productDto
          ? this.productMapperFactory
              .createMapper(ProductMapper, mappperParams)
              .toDomain(productDto)
          : null;
      })
    );
  }

  /**
   * Return required variables value to graphql query.
   * @param fundDataServiceParams params required for graphql query
   */
  private getVariables(
    fundDataServiceParams: FundDataServiceParams
  ): Record<string, any> {
    return {
      countrycode: this.getCountry(),
      languagecode: this.getLanguage(),
      fundid: fundDataServiceParams.fundId,
    };
  }
}
